import { Injectable } from '@angular/core';
import { AbstractHttpService } from './abstract-http-service';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdvancedSettingsService extends AbstractHttpService {
  defaultOptions = {
    headers: this.contentTypeJsonHeaders,
    withCredentials: true
  };

  resetMappingHeaders = {
    headers: this.contentTypeFormUrlEncodedHeaders,
    withCredentials: true
  };

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Gets Advanced settings for the account
   */
  public getAdvancedSettings(accountId: number): Observable<any> {
    return this.httpClient
      .get(
        `//${environment.autoDomain}:${environment.autoPort}/api/advanced/${accountId}`,
        this.defaultOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Updates Advanced Settings
   * PUT /api/advanced-settings
   * Payload should match AdvancedSettingsRequest shape expected by backend
   */
  public updateAdvancedSettings(settings: any): Observable<any> {
    return this.httpClient.put(
      `//${environment.autoDomain}:${environment.autoPort}/api/advanced/${settings.accountId}`,
      settings,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Rebuilds the account's ad cache through LaunchControl's manual refresh action.
   */
  public refreshCache(accountId: number): Observable<void> {
    return this.httpClient.post(
      `/settings/globals/view-specials-globals-admin/${accountId}`,
      'refresh-cache=Refresh%20Cache',
      {
        headers: this.contentTypeFormUrlEncodedHeaders,
        withCredentials: true,
        responseType: 'text'
      }
    ).pipe(
      catchError(this.handleError),
      map(html => {
        // Login redirects and disabled pre-caching can return HTML with status 200.
        if (!html.includes('Cache has been manually refreshed')) {
          throw new Error('Cache refresh completion was not confirmed.');
        }
      })
    );
  }
}
